import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-type-fast-number',
  templateUrl: 'type-fast-number.html',
  styleUrls: ['/type-fast-number.scss'],
})
export class TypeFastNumber {
  @Input() cardContent: string = '';
  isSelected: boolean = false;

  toggleSelection() {
    this.isSelected = !this.isSelected;
  }
}



// WEBPACK FOOTER //
// ./src/component/TypeFastNumber/type-fast-number.ts